import React from 'react';
import moment from 'moment';

import {
    Table,
    Button,
    Select,
} from 'antd'

import { API_ENDPOINT } from '../../index'

import ViewDataModal from './view-data-modal';

const { Option } = Select;

class UpdateHistoryTable extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            timestampFormat: 'iso',

            modalVisible: false,
            selectedData: [],
            selectedType: '',
            selectedUUID: ''
        }
    }

    render() {
        return (
            <div>
                {this.renderTable()}
                <ViewDataModal 
                    visible={this.state.modalVisible}
                    data={this.state.selectedData}
                    selectedType={this.state.selectedType}
                    selectedUUID={this.state.selectedUUID}
                    handleCloseModal={this.handleCloseModal}
                    />
            </div>

        )
    }

    renderTable = () => {

        const { updateHistories, loading, page, limit, updateHistoriesCount } = this.props
        const { timestampFormat } = this.state

        const columns = [{
            title: 'Id',
            dataIndex: 'uuid',
        },{
            title: this.renderTimestampTitle(),
            dataIndex: 'dateCreated',
            render: (dateCreated) => timestampFormat=='iso' ? moment(dateCreated).toISOString() : moment(dateCreated).format(timestampFormat)
        },{
            title: 'Updated',
            dataIndex: 'updatedData',
            render: (updatedData) => updatedData.length
        },{
            title: 'Errors',
            dataIndex: 'errorData',
            render: (errorData) => errorData.length > 0 ? <div style={{color: 'red'}}>{errorData.length}</div> : errorData.length
        },{
            title: 'Actions',
            render: (action, record) => this.renderActions(record)
        }]

        return <Table 
            loading={loading}
            dataSource={updateHistories}
            columns={columns}
            pagination={{
                current: page,
                pageSize: limit,
                total: updateHistoriesCount,
                onChange: this.props.onTablePageChange
            }}

        />
    }

    renderTimestampTitle = () => {
        return (
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <div style={{marginRight: 12}}>Timestamp</div>

                <div style={{marginRight: 4, fontSize: 12}}>Format:</div>
                <Select style={{ width: 150 }} onChange={this.handleTimestampFormatChange}>
                    <Option value='iso'>2021-01-01T00:00:00.000Z</Option>  
                    <Option value='Do MMMM YYYY'>1st Jan 2021</Option>  
                    <Option value='Do MMMM YYYY HH:mm:ss'>1st Jan 2021 00:00:00</Option>  
                    <Option value='DD/MM/YYYY'>01/01/2021</Option>  
                    <Option value='DD/MM/YYYY HH:mm:ss'>01/01/2021 00:00:00</Option>  
                </Select>
            </div>
        )
    }

    handleTimestampFormatChange = (e) => {
        this.setState({
            timestampFormat: e
        })
    }

    renderActions = (record) => {

        return (
            <div style={{display: 'grid', gridTemplateColumns: '1fr', gridRowGap: 8}}>
                {record.errorData && record.errorData.length > 0 &&
                    <div>
                        <Button
                            icon="eye"
                            onClick={() => this.handleOpenModal(record, 'error')}
                            style={{ marginRight: 8 }}>Errors</Button>
                        <Button
                            icon="download"
                            type="primary"
                            href={`${API_ENDPOINT}/api/stock-integration/update-history/download/error/${record._id}`}>Errors</Button>
                    </div>
                }
                {record.updatedData && record.updatedData.length > 0 &&
                    <div>
                        <Button
                            icon="eye"
                            onClick={() => this.handleOpenModal(record, 'updated')}
                            style={{ marginRight: 8 }}>Updated</Button>
                        <Button
                            icon="download"
                            type="primary"
                            href={`${API_ENDPOINT}/api/stock-integration/update-history/download/updated/${record._id}`}>Updated</Button>
                    </div>
                }
            </div>
        )

    } 

    handleOpenModal = (record, type) => {

        let selectedData = []

        if (type=='error') {
            selectedData = record.errorData.map((_error,idx) => {
                let dataRow = {
                    ..._error,
                    ...record.errorBool[idx]
                }
                return dataRow
            })
        }
        if (type=='updated') {
            selectedData = record.updatedData
        }

        this.setState({
            modalVisible: true,
            selectedData: selectedData,
            selectedType: type,
            selectedUUID: record.uuid,
        })
    }

    handleCloseModal = () => {
        this.setState({
            modalVisible: false,
            selectedData: [],
        })
    }



}

export default UpdateHistoryTable


// WEBPACK FOOTER //
// ./src/components/stock-integration/update-history-table.js